import { render, staticRenderFns } from "./Anggota.vue?vue&type=template&id=810cfa9a"
import script from "./Anggota.vue?vue&type=script&lang=js"
export * from "./Anggota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports